initAutoSizes();
function initAutoSizes() {
  const images = document.querySelectorAll('img[data-auto-sizes]');

  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      const img = entry.target;
      const width = img.clientWidth;
      const height = img.clientHeight;

      // Don't change if invisible
      if (width == 0 || height == 0) return;

      const parentRatio = img.parentNode.clientWidth / img.parentNode.clientHeight;
      const imageRatio = width / height;

      // Determine if the image is in a landscape or portrait orientation
      const isLandscape = imageRatio > parentRatio;

      // Adjust the sizes attribute based on the image orientation
      if (isLandscape) {
        img.setAttribute('sizes', `${width}px`);
        img.dataset.landscape = 'true';
      } else {
        img.setAttribute('sizes', `${height}px`);
      }
    });
  });

  images.forEach((img) => {
    resizeObserver.observe(img);
  });
}
